








































































































































































































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  HistoryActivity,
  ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';
import {
  TimeTransactionInitState
} from '@/store/time-transaction/time-transaction.types';
import {Helper} from '../../../util/helper';

@Component({
  components: {}
})
export default class HistorySelfComponent extends Vue {

  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('timeTransaction') timeTransactionInitState!: TimeTransactionInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getAllServiceActivityHistoryByMember', {namespace: 'serviceTransaction'}) getAllServiceActivityHistoryByMember!: (payload: {memberId:string, page:number, limit:number}) => Promise<void>;
  @Action('_getTimeTransaction', {namespace: 'timeTransaction'}) getTimeTransaction!: (payload: string) => Promise<void>;

  public lib: Helper = new Helper();
  public listHistoryActivity = [] as HistoryActivity[];
  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
  public type = [
    {id: 1, name: 'ส่งคำเชิญถึงผู้รับบริการ'},
    {id: 2, name: 'ส่งคำเชิญถึงผู้ให้บริการ'},
    {id: 3, name: 'ประวัติการแลกเปลี่ยน'}
  ];

  public filter = {
    memberId: '',
    page:1,
    limit:30
  }

  async mounted() {
    this.filter.memberId = this.loginInfo.id
    await this.getAllServiceActivityHistoryByMember(this.filter);
    this.listHistoryActivity = this.serviceTransactionInitState.historyActivity;
    await this.Loading(false);
  }

}
